module.exports = __webpack_public_path__ + "a79f5e33b70e5b46548abc25072ca60d.pdf";